import { useState, useEffect } from "react";

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Fade from "@mui/material/Fade";
import useScrollTrigger from "@mui/material/useScrollTrigger";

import SuiTypography from "components/SuiTypography";
import SuiBox from "components/SuiBox";

import breakpoints from "assets/theme/base/breakpoints";

import CompanyInfo from "pages/ma/edit-profile/components/CompanyInfo";
import ContactInfo from "pages/ma/edit-profile/components/ContactInfo";
import ProjectRequirement from "pages/ma/edit-profile/components/ProjectRequirement";
import ManufacturingSpecialties from "pages/ma/edit-profile/components/ManufacturingSpecialties";
import ServicesOffered from "pages/ma/edit-profile/components/ServicesOffered";
import NewMediaInfo from "pages/ma/edit-profile/components/NewMediaInfo";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <SuiBox sx={{ py: 3 }}>
          <div>{children}</div>
        </SuiBox>
      )}
    </div>
  );
}

function ScrollTop(props) {
  const { children } = props;

  const trigger = useScrollTrigger();

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector("#back-to-top-anchor");
    if (anchor) {
      anchor.scrollIntoView({
        block: "center",
      });
    }
  };

  return (
    <Fade in={trigger}>
      <SuiBox
        onClick={handleClick}
        role="presentation"
        sx={{ position: "fixed", bottom: 16, right: 16 }}
      >
        {children}
      </SuiBox>
    </Fade>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const EditProfile = () => {
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    /** 
       The event listener that's calling the handleTabsOrientation function when resizing the window.
      */
    window.addEventListener("resize", handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  const handleSetTabValue = (event, newValue) => setTabValue(newValue);

  const handleNextTab = () => {
    let newTableValue = tabValue + 1;
    setTabValue(newTableValue < 3 ? newTableValue : 3);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handlePrevTab = () => {
    let newTableValue = tabValue - 1;
    setTabValue(newTableValue >= 0 ? newTableValue : 0);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="large:px-36 medium:px-8 small:px-4 xsmall:px-1">
      <AppBar position="sticky" sx={{ top: "1%" }} id="back-to-top-anchor">
        <Tabs orientation={tabsOrientation} value={tabValue} onChange={handleSetTabValue}>
          <Tab label="General Info" {...a11yProps(0)} />
          <Tab label="Manufacturing Details" {...a11yProps(1)} />
          <Tab label="Services Offered" {...a11yProps(2)} />
          <Tab label="Images & Videos" {...a11yProps(3)} />
        </Tabs>
      </AppBar>
      <div>
        <TabPanel value={tabValue} index={0}>
          <CompanyInfo saveNext={handleNextTab} />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <ProjectRequirement saveNext={handleNextTab} />
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <ServicesOffered saveNext={handleNextTab} />
        </TabPanel>
        <TabPanel value={tabValue} index={3}>
          <NewMediaInfo />
        </TabPanel>
      </div>
      <ScrollTop>
        <Fab size="small" aria-label="scroll back to top">
          <KeyboardArrowUpIcon />
        </Fab>
      </ScrollTop>
    </div>
  );
};

export default EditProfile;
